import _ from "lodash";
import {
    Chord,
    Tone
} from "../model/core";
import { Tonality } from "../model/scales";

export namespace RydMusic {

    // type ScalePattern = {
    //     name: string,
    //     activeSteps: number[],
    // };

    // type ScaleMode = {
    //     name: string,
    //     startingStep: number,
    // }

    // type ScaleType = {
    //     name: string,
    //     pattern: ScalePattern,
    //     mode: ScaleMode,
    // };

    // export type Scale = {
    //     rootTone: Tone,
    //     scaleType: ScaleType
    // };

    export namespace DiatonicChords {
        export const buildFromScale: (getChordIdByNotes, tonality: Tonality) => Chord[][] = (getChordIdByNotes, tonality) => {
            const steps = 3;
            const skip = 1; // 3rds
            const root = tonality.center;
            // const pattern = scale.intervalPattern.toActiveSteps();
            // // const mode = scale.scaleType.mode.startingStep;

            // const chordsInScaleDegrees = pattern.map((step, index) => {
            //     return _.range(0, steps).map((i) => {
            //         const chordNote = pattern[((index + i * (skip + 1))) % pattern.length];
            //         return (chordNote) % 12;
            //     });
            // });

            const chordsInScaleDegrees = tonality.getHarmonicFieldChords();

            return chordsInScaleDegrees.map((nAdicChords, index) => {

                return nAdicChords.map((chord, index) => {
                    return chord.map((t: Tone) => t.index);
                }).map((chord, index) => {

                    return getChordIdByNotes(chord).then(c => c);
                });
            });
        }
    }
};
